<ng-container *ngIf="poseeAgenda">
  <mat-expansion-panel hideToggle expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title> Datos de entrega de equipo(s) </mat-panel-title>
      <ng-container>
        <mat-panel-description>
            
        </mat-panel-description>
      </ng-container>
    </mat-expansion-panel-header>
    <ng-container>
      <div class="row-agenda-entrega">
        <app-carrusel-agenda></app-carrusel-agenda>
      </div>
    </ng-container>
    <ng-container *ngIf="false">
  
      <div
        class="d-flex row-agenda-direccion justify-content-between align-items-center"
        *ngIf="false"
      >
        <div class="flex-column">
          <p class="txt-titulo-agenda">Dirección de entrega</p>
          <p class="txt-detalle">
            {{ datosDireccion.direccion }} {{ datosDireccion.numero }}
            {{ datosDireccion.complemento }}
          </p>
        </div>
        <button
          class="d-flex btn-secondary-tbk btn-editar align-items-center"
          type="button"
          value="Editar"
          (click)="edDireccion()"
        >
          <img src="assets/icons/editar.png" />
          <p class="m-0">Editar</p>
        </button>
      </div>
    
      <div
        [formGroup]="direccionEntrega"
        class="row-agenda-entrega"
        *ngIf="editarDireccion"
      >
        <app-messages
          class="informativo"
          message="Modifica estos datos si necesitas que el producto se entregue en una dirección distinta a tu dirección comercial (Diego de Almagro 2305, 305, Providencia)."
        >
        </app-messages>
        <div class="row">
          <div class="col-md-12 mt-362 mt-36">
            <label for="direccionCompleta">Dirección completa</label>
            <input
              type="text"
              name="direccionCompleta"
              formControlName="direccionCompleta"
              placeholder="Buscar dirección"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-36">
            <label for="region">Region</label>
            <select name="region" formControlName="region">
              <option Value="metropolitana">Región metropolitana</option>
              <option value="" selected>Región metropolitana</option>
              <option value="test">test</option>
            </select>
          </div>
          <div class="col-md-6 mt-36">
            <label for="comuna">Comuna</label>
            <select name="comuna" formControlName="comuna">
              <option Value="penalolen">Peñalolen</option>
              <option value="" selected>Peñalolen</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-36">
            <label for="avenidaCallePasaje">Avenida/Calle/Pasaje</label>
            <input
              appCaracteresNumeros
              type="text"
              formControlName="avenidaCallePasaje"
              name="avenidaCallePasaje"
              placeholder="Ingresar Avenida / Calle / Pasaje"
              autocomplete="off"
            />
          </div>
          <div class="col-md-6 mt-36">
            <label for="numeroCalle">Número calle</label>
            <input
              appNumeros
              formControlName="numeroCalle"
              type="text"
              name="numeroCalle"
              placeholder="Ingresar número calle "
              autocomplete="off"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mt-36">
            <label for="numeroLocal"
              >Número de local o departamento (opcional)</label
            >
            <input
              appNumeros
              type="text"
              name="numeroLocal"
              formControlName="numeroLocal"
              placeholder="Ingresar número de local"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="row box-button">
          <div class="col-md-4 d-flex justify-content-center">
            <input
              class="btn-secondary-tbk btn-volver"
              type="button"
              value="Volver"
              (click)="backDireccion()"
            />
          </div>
          <div class="col-md-4 d-flex justify-content-center">
            <input
              class="btn-primary-tbk"
              type="button"
              value="Guardar"
              (click)="actualizarDireccion()"
              [disabled]="direccionEntrega.status === 'INVALID'"
            />
          </div>
        </div>
      </div>
    
      <div
        class="d-flex row-agenda-recibo justify-content-between align-items-center"
      >
        <div class="flex-column">
          <p class="txt-titulo-agenda">¿Quién recibe el producto?</p>
          <mat-progress-bar mode="query" *ngIf="loading"></mat-progress-bar>
          <p class="txt-detalle" *ngIf="!loading">
            Nombre: <b>{{ nombreContactoRecibe }}</b
            >, Teléfono: <b>{{ numeroContactoRecibe }}</b>
          </p>
        </div>
    
        <button
          class="d-flex btn-secondary-tbk btn-editar align-items-center"
          type="button"
          value="Editar"
          (click)="edContacto()"
        >
          <img src="assets/icons/editar.png" />
          <p class="m-0">Editar</p>
        </button>
      </div>
      <div [formGroup]="recibeEntrega" *ngIf="editarContacto">
        <div class="row">
          <div class="col-md-12">
            <app-messages
              class="informativo"
              message="Completa estos campos si necesitas que otra persona reciba el o los productos a contratar."
            >
            </app-messages>
          </div>
          <div class="col-md-6">
            <label for="nombre">Nombre</label>
            <input
              appCaracteres
              type="text"
              name="nombre"
              formControlName="nombre"
              placeholder="Ingresa nombre"
              autocomplete="off"
              [class.inputInvalido]="
                recibeEntrega.get('nombre').invalid &&
                recibeEntrega.get('nombre').touched
              "
            />
          </div>
          <div class="col-md-6">
            <label for="primerApellido">Primer apellido</label>
            <input
              appCaracteres
              type="text"
              name="primerApellido"
              formControlName="primerApellido"
              placeholder="Ingresa primer apellido"
              autocomplete="off"
              [class.inputInvalido]="
                recibeEntrega.get('primerApellido').invalid &&
                recibeEntrega.get('primerApellido').touched
              "
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="telefono">Teléfono</label>
            <span class="prefijo">+56</span>
            <input
              appNumeros
              inputmode="numeric"
              pattern="\d*"
              type="text"
              class="pre-input"
              name="telefono"
              formControlName="telefono"
              placeholder="Ingresar hasta 10 digitos"
              autocomplete="off"
              [class.inputInvalido]="
                (recibeEntrega.get('telefono').invalid &&
                  recibeEntrega.get('telefono').touched) ||
                recibeEntrega.get('telefono').hasError('minlength')
              "
              (input)="habilitarBtnGuardarContacto()"
            />
          </div>
        </div>
        <div class="row box-button">
          <div class="col-md-4 d-flex justify-content-center">
            <input
              class="btn-secondary-tbk btn-volver"
              type="submit"
              value="Volver"
              (click)="backContacto()"
            />
          </div>
          <div class="col-md-4 d-flex justify-content-center">
            <input
              class="btn-primary-tbk"
              type="button"
              value="Guardar"
              (click)="postContacto()"
              [disabled]="recibeEntrega.status === 'INVALID'"
            />
          </div>
        </div>
      </div>
    </ng-container>
  </mat-expansion-panel>
</ng-container>
